import template from './confirm.html';
import { actions, selectors } from '../../../../state';
import './confirm.global.css';

const TOAST_ERROR = 'Sorry. There was an error saving your move information.';

class ConfirmMoveController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Not connecting since it's populating form data
    const state = getState();
    const move = selectors.current.move(state);
    this.move = {
      id: move.id(state),
      date: move.date(state),
      from_address: move.fromAddress(state),
      to_address: move.toAddress(state),
    };
  }

  $onDestroy() {
    this.disconnect();
  }

  onSubmitted({ move }) {
    const { dispatch } = this.updStore;
    const success = () => dispatch(actions.router.stateGo(this.successState));
    const error = () => dispatch(actions.message.error(TOAST_ERROR));

    const body = { ...move, confirmed: true };
    dispatch(actions.move.singleton(body.id).update(body)).then(success, error);
  }
}

function mapStateToThis(state) {
  return {
    submitting: selectors.pending.match(actions.move.isUpdate, state),
    successState: selectors.router.currentDataSuccessState(state),
  };
}

export const ConfirmMoveComponent = {
  template,
  controller: ConfirmMoveController,
};
